import { createSlice } from '@reduxjs/toolkit';

const hotelSlice = createSlice({
    name: 'hotel',
    initialState: {
        bookingOption: {
            selectedPeople: null,
            selectedDate: null,
            selectedTime: null,
        },
        iconSet: {
            storeIcon: null,
            categoryIcon: null,
        },
        productModalVisible: false,
        jmModalVisible: false,
        pmList: [],
        recomActivities: [],
        onlinePay: {},
        productBookingRule: null,
        ownBookingRule: null,
        promotionActivityId: null,
        addCartFromActivity: null // 从活动添加购物车的 productId
    },
    reducers: {
        setPromotionActivityId: (state, action) => {
            state.promotionActivityId = action.payload;
        },
        setOwnBookingRule: (state, action) => {
            state.ownBookingRule = action.payload;
        },
        resetBookingOption: (state) => {
            state.bookingOption = {
                selectedPeople: null,
                selectedDate: null,
                selectedTime: null,
            };
        },
        setBookingOption: (state, action) => {
            state.bookingOption = action.payload;
        },
        setIconSet: (state, action) => {
            state.iconSet = action.payload;
        },
        setProductModalVisible: (state, action) => {
            state.productModalVisible = action.payload;
        },
        setJmModalVisible: (state, action) => {
            state.jmModalVisible = action.payload;
        },
        setPmList: (state, action) => {
            state.pmList = action.payload;
        },
        setRecomActivities: (state, action) => {
            state.recomActivities = action.payload;
        },
        setOnlinePay: (state, action) => {
            state.onlinePay = action.payload;
        },
        setProductBookingRule: (state, action) => {
            state.productBookingRule = action.payload
        },
        setAddCartFromActivity: (state, action) => {
            state.addCartFromActivity = action.payload
        },
        clearAddCartFromActivity: (state) => {
            state.addCartFromActivity = null
        }
    },
});

export const {
    setBookingOption,
    setIconSet,
    resetBookingOption,
    setProductModalVisible,
    setJmModalVisible,
    setPmList,
    setRecomActivities,
    setOnlinePay,
    setProductBookingRule,
    setOwnBookingRule,
    setPromotionActivityId,
    setAddCartFromActivity,
    clearAddCartFromActivity
} = hotelSlice.actions;

export const selectBookingOption = (state) => state.hotel.bookingOption;
export const selectIconSet = (state) => state.hotel.iconSet;
export const selectProductModalVisible = (state) => state.hotel.productModalVisible;
export const selectJmModalVisible = (state) => state.hotel.jmModalVisible;
export const selectPmList = (state) => state.hotel.pmList;
export const selectRecomActivities = (state) => state.hotel.recomActivities;
export const selectOnlinePay = (state) => state.hotel.onlinePay;
export const selectProductBookingRule = (state) => state.hotel.productBookingRule;
export const selectOwnBookingRule = (state) => state.hotel.ownBookingRule;
export const selectPromotionActivityId = (state) => state.hotel.promotionActivityId;
export const selectAddCartFromActivity = (state) => state.hotel.addCartFromActivity;
export default hotelSlice.reducer;